import { render, staticRenderFns } from "./MyPayslips.vue?vue&type=template&id=953b4836&scoped=true"
import script from "./MyPayslips.vue?vue&type=script&lang=js"
export * from "./MyPayslips.vue?vue&type=script&lang=js"
import style0 from "./MyPayslips.vue?vue&type=style&index=0&id=953b4836&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "953b4836",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tomi/Projects/ingeniAR/rrhh/Frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('953b4836')) {
      api.createRecord('953b4836', component.options)
    } else {
      api.reload('953b4836', component.options)
    }
    module.hot.accept("./MyPayslips.vue?vue&type=template&id=953b4836&scoped=true", function () {
      api.rerender('953b4836', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/MyPayslips/MyPayslips.vue"
export default component.exports